"use client";

const OnlineChat = ({ journal }: { journal: Journal }) => {
  return (
    <>
      {/* We did not implement Comm100 Live Chat because it is not being used. */}
    </>
  );
};

export default OnlineChat;
